import {
  DEFAULT_CURRENCY_DECIMAL_SEPARATOR,
  DEFAULT_CURRENCY_THOUSAND_SEPARATOR,
  DEFAULT_PRECISION,
  displayCurrencySymbol,
  getCurrencyFormatter,
  getStepForCurrencyPrecision,
} from '@utils/currency';

const PART_TYPE_GROUP = 'group';
const PART_TYPE_DECIMAL = 'decimal';
const PART_TYPE_CURRENCY = 'currency';
const PART_TYPE_INTEGER = 'integer';
const SAMPLE_NUMBER = 1234.1234;
const SYMBOL_POSITION_LEFT = 'left';
const SYMBOL_POSITION_RIGHT = 'right';

export interface CurrencyFormatOptions {
  currency?: string;
  decimalSeparator: string;
  precision: number;
  step: number;
  symbol: string;
  symbolPosition?: typeof SYMBOL_POSITION_LEFT | typeof SYMBOL_POSITION_RIGHT;
  thousandSeparator: string;
}

export const getCurrencyFormatOptions = (currency: string, precision = DEFAULT_PRECISION): CurrencyFormatOptions => {
  const parts = getCurrencyFormatter(currency, precision).formatToParts(SAMPLE_NUMBER);

  const group = parts.find(p => p.type === PART_TYPE_GROUP)?.value;
  const decimal = parts.find(p => p.type === PART_TYPE_DECIMAL)?.value;
  const currencyIndex = parts.findIndex(p => p.type === PART_TYPE_CURRENCY);
  const numberIndex = parts.findIndex(p => p.type === PART_TYPE_INTEGER);
  const symbolPosition = currencyIndex < numberIndex
    ? SYMBOL_POSITION_LEFT
    : SYMBOL_POSITION_RIGHT;

  return {
    currency,
    decimalSeparator: decimal || DEFAULT_CURRENCY_DECIMAL_SEPARATOR,
    precision,
    step: getStepForCurrencyPrecision(precision),
    symbol: displayCurrencySymbol(currency),
    symbolPosition,
    thousandSeparator: group || DEFAULT_CURRENCY_THOUSAND_SEPARATOR,
  };
};
